import _ from 'lodash';
import queryString from 'query-string';

const DEFAULT_CONFIG = {
  mode: 'cors',
  redirect: 'follow',
};

const headers = new Headers({
  'Content-Type': 'application/json',
});

const get = ({ url, query }) => fetch(`${url}${(query && !_.isEmpty(query)) ? `?${queryString.stringify(query)}` : ''}`, {
  ...DEFAULT_CONFIG,
  method: 'GET',
}).then((res) => res.json());

const post = ({ url, query, body }) => fetch(`${url}?${queryString.stringify(query)}`, {
  ...DEFAULT_CONFIG,
  method: 'POST',
  body: JSON.stringify(body),
  headers,
}).then((res) => res.json());

export default {
  get,
  post,
};
